// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__c2xbI system_captionL__E1FNu","arrow":"styles_arrow__sG77U","center":"styles_center__2oBBv","end":"styles_end__Tfv3n","start":"styles_start__Dlfa6"};